import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type Session from "cc-frontend/services/session"

interface Args {
  planbook: Planbook
  rotationCalendar: RotationCalendar
  goToEditClasses: Function
  goToConfirmDeletePlanbook: Function
  goToAdjustWeeklyOrder: Function
  goToEditTitle: Function
  goToEditPlanbook: Function
  goToConfirmMigrateToUnifiedLessons: () => void
  showSettingsEditor: Function
  showTemplateChooser: Function
  closeMenu: Function
}

export default class PlanbookMenuPrimaryBodyComponent extends Component<Args> {
  @service declare router
  @service declare session: Session

  @action goToClassWebsites() {
    this.router.transitionTo("planbookv5.class-websites")
    this.args.closeMenu()
  }

  @action goToSharing() {
    this.router.transitionTo("planbookv5.sharing")
    this.args.closeMenu()
  }
}
